<template>
  <div style="width: 100%">
    <v-card>
      <v-card-title>
        <h3 class="headline mt-0">{{ $t('Add/Remove to cart') }}</h3>
      </v-card-title>
      <v-card-text>
        <label>{{ $t('Options') }}</label>
        <div class="form-control mb-4" :class="{ 'has-error': errors.has('method') }">
          <v-radio-group
            name="method"
            row
            :data-vv-as="$t('Options')"
            v-model="optype"
            v-validate="'required'"
            :error="errors.has('method')"
            :error-messages="errors.first('method')"
          >
            <v-radio color="primary" :value="'addtocart'" :label="$t('Add')"></v-radio>
            <v-radio color="primary" :value="'removetocart'" :label="$t('Remove')"></v-radio>
            <v-radio
              color="primary"
              :value="'removeandaddtocart'"
              :label="$t('Clear&Add')"
            ></v-radio>
          </v-radio-group>
          <!-- <span class="text-error" v-if="errors.has('method')">{{ errors.first('method') }}</span> -->
        </div>
        <div v-for="(item, k) in items" :key="k">
          <v-card>
            <v-card-text style="position: relative">
              <div class="text-xs-right">
                <v-btn
                  @click="items.splice(k, 1)"
                  small
                  icon
                  style="position: absolute; right: 0; top: 0"
                >
                  <span class="material-icons">delete_outline</span>
                </v-btn>
              </div>
              <div :style="{ 'min-height': expandForSelect === k ? '300px' : '' }">
                <div class="form-control" :class="{ 'has-error': errors.has('product') }">
                  <label>{{ $t('Products') }}</label>
                  <template v-if="['thailandpostmart'].includes(selectedBot.type)">
                    <multiselect
                      v-validate="'required'"
                      :data-vv-as="$t('Product')"
                      :placeholder="$t('Select Product')"
                      name="product"
                      v-model="thailandpostmartItems.sku"
                      @select="onThailandpostmartSelectedProduct"
                      :options="filterProducts"
                      @open="expandForSelect = k"
                      @close="expandForSelect = ''"
                      return="id"
                      label="product_title"
                      :maxHeight="250"
                      :openDirection="'below'"
                      :close-on-select="true"
                    ></multiselect>
                    <multiselect
                      v-if="thailandpostmartOptions && thailandpostmartOptions.length > 0"
                      v-validate="'required'"
                      :data-vv-as="$t('Product')"
                      :placeholder="$t('Select Option')"
                      name="thailandpostmartOptions"
                      v-model="item.pid"
                      @select="onThailandpostmartSelectedProduct"
                      :options="thailandpostmartOptions"
                      @open="expandForSelect = k"
                      @close="expandForSelect = ''"
                      return="id"
                      label="product_title"
                      :maxHeight="250"
                      :openDirection="'below'"
                      :close-on-select="true"
                    ></multiselect>
                  </template>
                  <multiselect
                    v-else
                    v-validate="'required'"
                    :data-vv-as="$t('Product')"
                    :placeholder="$t('Select Product')"
                    name="product"
                    v-model="item.pid"
                    @select="onSelectedProduct(k)"
                    :options="filterProducts"
                    @open="expandForSelect = k"
                    @close="expandForSelect = ''"
                    return="id"
                    label="name"
                    :maxHeight="250"
                    :openDirection="'below'"
                    :close-on-select="true"
                  ></multiselect>
                  <span class="text-error" v-if="errors.has('product')">{{
                    errors.first('product')
                  }}</span>
                </div>
                <v-layout row rows wrap>
                  <v-flex xs12 lg7 style="padding-right: 5px">
                    <div class="form-control" :class="{ 'has-error': errors.has('option') }">
                      <label>{{ $t('stock') }}</label>
                      <multiselect
                        name="option"
                        :data-vv-as="$t('Options')"
                        v-validate="'required'"
                        v-model="item.option"
                        :options="$options.filters.filteredStock(item)"
                        @open="expandForSelect = k"
                        @close="expandForSelect = false"
                        :placeholder="$t('Select Stock')"
                        :maxHeight="250"
                        :openDirection="'below'"
                        :close-on-select="true"
                      ></multiselect>
                      <span class="text-error" v-if="errors.has('option')">{{
                        errors.first('option')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 lg3>
                    <div class="form-control" :class="{ 'has-error': errors.has('quantity') }">
                      <label>{{ $t('quantity') }}</label>
                      <input
                        v-validate="'required'"
                        type="text"
                        name="quantity"
                        :data-vv-as="$t('quantity')"
                        v-model="item.qty"
                        @keypress="isNumber($event, item.qty)"
                      />
                      <span class="text-error" v-if="errors.has('quantity')">{{
                        errors.first('quantity')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex v-if="$store.getters.getPackage == 'premium'" lg2>
                    <IntentPrefillCartAddRemove
                      @show=";['Number']"
                      @onAddPrefill="onAddPrefill($event, item)"
                    ></IntentPrefillCartAddRemove>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="text-xs-center my-3">
          <v-btn @click="additem" flat color="green">
            <span class="material-icons">add</span>
            {{ $t('Add product') }}
          </v-btn>
        </div>

        <!-- <template v-if="$route.name == 'Comment to inbox' && optype == 'addtocart'">
          <v-divider />
          <h3 class="headline">{{ $t('Limit reply to inbox') }}</h3>
          <v-checkbox
            v-model="checkstock"
            color="primary"
            :label="$t('Reply to inbox depends on stock')"
            hide-details
            @change="changecheckstock"
          ></v-checkbox>
          <div class="ml-4 pl-2">
            <v-checkbox
              v-model="adjuststock"
              color="primary"
              :label="$t('Real-time inventory after reply to inbox')"
              hide-details
              :disabled="checkstock == false"
            ></v-checkbox>
          </div>
          <v-divider class="my-4" />
          <v-checkbox
            v-model="checksameproductincarts"
            color="primary"
            :label="$t('Refusing to reply users who has product(s) in the cart')"
            hide-details
          ></v-checkbox>
        </template> -->
        <div class="text-xs-center mt-2">
          <v-btn @click="close" outline color="grey">CANCEL</v-btn>

          <v-btn v-if="data" @click="update" depressed color="primary">UPDATE</v-btn>
          <v-btn v-else @click="save" depressed color="primary">SAVE</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import IntentPrefillCartAddRemove from '@/components/elements/IntentPrefillCartAddRemove.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'

export default {
  props: ['data'],
  data() {
    return {
      optype: '',
      loading: false,
      expandForSelect: false,
      items: [
        {
          qty: '',
          pid: '',
          option: ''
        }
      ],
      checkstock: false,
      checksameproductincarts: false,
      adjuststock: false,
      thailandpostmartItems: [
        {
          sku: ''
        }
      ],
      thailandpostmartOptions: []
    }
  },
  components: {
    multiselect,
    IntentPrefillCartAddRemove
  },
  mounted() {
    if (this.data) {
      this.optype = this.data.type
      this.product = this.products.filter((el) => el.id == this.data.pid)[0]
      this.items = this.data.input
      this.items = this.items.map((el) => {
        return { ...el, pid: this.products.find((val) => val.id == el.pid) }
      })
      this.checksameproductincarts = this.data.hasOwnProperty('checksameproductincarts')
        ? this.data.checksameproductincarts
        : false
      this.checkstock = this.data.hasOwnProperty('checkstock') ? this.data.checkstock : false
      this.adjuststock = this.data.hasOwnProperty('adjuststock') ? this.data.adjuststock : false
    }
  },
  computed: {
    filterProducts() {
      return this.products
    },
    // filterStocks() {
    //   if (this.product) {
    //     return this.product.productstock.map(el => el[1])
    //   } else {
    //     return []
    //   }
    // },
    ...mapGetters({ selectedBot: 'selectedBot', products: 'getProducts' })
  },
  methods: {
    changecheckstock(value) {
      if (!value) {
        this.adjuststock = false
      }
    },
    isNumber: function (evt, qty) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) ||
        !/^[0-9]*$/gm.test(qty)
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onAddPrefill(v, item) {
      item.qty = v
    },
    additem() {
      this.items.push({
        option: '',
        pid: '',
        qty: ''
      })
    },
    update() {
      var data = this.items.map((el) => {
        return { pid: el.pid.id, qty: el.qty, option: el.option }
      })
      this.$emit('updateRemoveAndAdd', {
        type: this.optype,
        data: data,
        index: this.data.index,
        checkstock: this.optype == 'addtocart' ? this.checkstock : false,
        checksameproductincarts: this.optype == 'addtocart' ? this.checksameproductincarts : false,
        adjuststock: this.optype == 'addtocart' ? this.adjuststock : false
      })

      this.close()
    },
    close() {
      this.optype = ''
      this.stock = ''
      this.product = ''
      this.quantity = ''
      this.$emit('close')
    },
    save() {
      var vm = this
      // var data = {
      //   pid: this.product.id,
      //   qty: this.quantity,
      //   option: this.stock
      // }
      this.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          reject()
          return false
        }
        var data = vm.items.map((el) => {
          return { pid: el.pid.id, qty: el.qty, option: el.option }
        })

        vm.$emit('addIntentItem', vm.optype, {
          obj: data,
          checkstock: this.optype == 'addtocart' ? vm.checkstock : false,
          checksameproductincarts: this.optype == 'addtocart' ? vm.checksameproductincarts : false,
          adjuststock: this.optype == 'addtocart' ? vm.adjuststock : false
        })

        vm.close()
      })
    },
    onSelectedProduct(k) {
      this.items[k].option = ''
    },
    onThailandpostmartSelectedProduct(item) {
      if (item && item.product_attribute) {
        this.thailandpostmartOptions = item.product_attribute
      }
    }
  },
  filters: {
    filteredStock: function (value) {
      if (value && value.pid) {
        return value.pid.productstock.map((el) => el[1])
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentCartAddRemove.vue